module.exports = __webpack_public_path__ + "static/media/t21.23eb1137.jpg";